import AlertViewPage from "pages/alert/view";
import {
  AlertViewAccountInfo,
  AlertViewInfo,
} from "api/interfaces/alertInterface.interface";
import { Suspense } from "react";
type Props = {
  selectedAlert: AlertViewInfo;
  setAccountInfo: (accountInfo: AlertViewAccountInfo[]) => void;
};

const RecorderDetailAlert = ({
  selectedAlert,
  setAccountInfo,
}: Props): JSX.Element => {
  const params = new URLSearchParams({
    recorderId: selectedAlert.recorderId,
    // alertType: selectedAlert.category ?? "",
    // historyId: selectedAlert.historyId,
  });

  return (
    <Suspense>
      <AlertViewPage searchParams={params} setAccountInfo={setAccountInfo} />
    </Suspense>
  );
};

export default RecorderDetailAlert;
